import { Injectable } from '@angular/core';
import { ComponentResolverService } from '../services';
export class ComponentResolverMockService extends ComponentResolverService {static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ComponentResolverMockService_tsickle_Closure_declarations() {
/** @type {?} */
ComponentResolverMockService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ComponentResolverMockService.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
